import Layer from './ParallaxLayer';
import BGImg from './ParallaxBgImg';
import centerViewport from './utils/centerViewport';
import scroll from './utils/scroll';
import setBodyDimension from './utils/setBodyDimension';
import scrollToPosition from './utils/scrollToPosition';

export {
  Layer,
  BGImg,
  centerViewport,
  scroll,
  setBodyDimension,
  scrollToPosition,
};



// WEBPACK FOOTER //
// ./src/components/Parallax/index.js